import 'slick-carousel';
import g from './utils/globalVariables.es6';

const SLIDER_SELECTOR = '.js-slider';
const ARROW_LEFT_MARKUP =
  '<button type="button" class="slick-prev slick-arrow"><svg class="icon icon-angle-left"><use xlink:href="#icon-angle-left"></use></svg></button>';
const ARROW_RIGHT_MARKUP =
  '<button type="button" class="slick-next slick-arrow"><svg class="icon icon-angle-right"><use xlink:href="#icon-angle-right"></use></svg></button>';
const SLIDER_SETTINGS = {
  infinite: false,
  mobileFirst: true,
  dots: false,
  arrows: true,
  prevArrow: ARROW_LEFT_MARKUP,
  nextArrow: ARROW_RIGHT_MARKUP,
};

const init = () => {
  if (g.$body.css('direction') == 'rtl') {
    SLIDER_SETTINGS.rtl = true;
  }
  $(SLIDER_SELECTOR).slick(SLIDER_SETTINGS);
};

export default init;
